// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  flipId: __t.u64().primaryKey().name("flip_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  fromCiv: __t.string().name("from_civ"),
  toCiv: __t.string().name("to_civ"),
  warId: __t.u64().name("war_id"),
  at: __t.timestamp(),
});
